import React, { useRef, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { setMemberPassword } from '../../../api/apiServices';

const MemberPassword = (user) => {

    const fullname = decodeURI(user.user[2]) + ' ' + decodeURI(user.user[4]) + ' ' + decodeURI(user.user[3])
    const pfnumber = user.user[1];


    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const userRef = useRef();
    const errRef = useRef();

    const [name, setName] = useState(fullname);
    const [pf_number, setPfNumber] = useState(pfnumber);

    const [password, setPassword] = useState('');
    const [validPassword, setValidPassword] = useState(false);
    const [passwordFocus, setPasswordFocus] = useState(false);


    const [confirmPassword, setConfirmPassword] = useState('');
    const [validMatch, setValidMatch] = useState(false);
    const [matchFocus, setMatchFocus] = useState(false);

    const [errMsg, setErrMsg] = useState('');

    // const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
    const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,24}$/;
    useEffect(() => {
        userRef.current.focus();
    }, [])

    useEffect(() => {
        setValidPassword(PWD_REGEX.test(password));
        setValidMatch(password === confirmPassword);
    }, [password, confirmPassword])

    useEffect(() => {
        setErrMsg('');
    }, [pf_number, password, confirmPassword])

    const handleCancel = () => {
        navigate(from, { replace: true });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = {
            pf_number: pf_number,
            password: password
        }

        const v2 = PWD_REGEX.test(password);
        if (!v2) {
            setErrMsg("Invalid Entry");
            return;
        }

        if (password === confirmPassword) {
            // try {
            setMemberPassword(data).then((response) => {
                if (response) {
                    confirmAlert({
                        customUI: ({ onClose }) => {
                            return (
                                <div className='confirm-container'>
                                    <h3>Password Setup</h3>
                                    <p>You have successfully setup your password</p>
                                    <p>Log in with your PF Number/Email and Password to access your information</p>
                                    <br />
                                    <div className='confirm-setup-buttons'>
                                        <button
                                            style={{ width: "100px" }}
                                            className="btn btn-success"
                                            onClick={(e) => { handleCancel(e); onClose(); }}
                                        >
                                            Ok
                                        </button><br />
                                    </div>
                                </div>
                            );
                        }
                    })
                } else {
                    console.log("failure")
                }
            })
        } else {
            setErrMsg('Passwords do not match. Try again !')
        }
    }

    const pswdForm = (
        <>
            <form onSubmit={handleSubmit}>
                <div className="input-group success">
                    <input
                        type="text"
                        id="name"
                        autoComplete="off"
                        style={{ fontWeight: 'bold' }}
                        onChange={(e) => setName(e.target.value)}
                        value={name}
                        readOnly
                        className='form-control'
                    />
                </div>
                <label htmlFor='password'>
                    <div className={validPassword ? "valid" : "hide"}>Password <i className="fas fa-check"></i></div>
                    <div className={validPassword || !password ? "hide" : "invalid"}>Password <i className="fas fa-times"></i></div>
                </label>
                <div className="input-group success">
                    <input
                        type="password"
                        id="password"
                        ref={userRef}
                        placeholder='Password'
                        autoComplete="off"
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        required
                        aria-invalid={validPassword ? "false" : "true"}
                        aria-describedby="pwdnote"
                        onFocus={() => setPasswordFocus(true)}
                        onBlur={() => setPasswordFocus(false)}
                        className='form-control'
                    />
                </div>
                <p id="pwdnote" className={passwordFocus && !validPassword ? "instructions" : "offscreen"}>
                    <i className="fas fa-info-circle"></i> 8 to 24 character password is required.<br />
                    Your password must include uppercase and lowercase letters, and a number. You may include any special character of your choice.<br />
                </p>
                <label htmlFor="confirm_password">
                    <div className={validMatch && confirmPassword ? "valid" : "hide"}> Confirm Password <i className="fas fa-check"></i></div>
                    <div className={validMatch || !confirmPassword ? "hide" : "invalid"}> Confirm Password <i className="fas fa-times"></i></div>
                </label>
                <div className="input-group success">
                    <input
                        type="password"
                        id="confirm_password"
                        placeholder='Confirm Password'
                        autoComplete="off"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        value={confirmPassword}
                        required
                        aria-invalid={validMatch ? "false" : "true"}
                        aria-describedby="confirmnote"
                        onFocus={() => setMatchFocus(true)}
                        onBlur={() => setMatchFocus(false)}
                        className='form-control'
                    />
                </div>
                <p id="confirmnote" className={matchFocus && !validMatch ? "instructions" : "offscreen"}>
                    <i className="fas fa-info-circle"></i> Must match the first password input field.
                </p>
                <br />
                <div className="form-group row">
                    <div className="col-sm-12">
                        <button
                            disabled={!validPassword || !validMatch ? true : false}
                            className='btn btn-success btn-block'>
                            Submit
                        </button>

                        <button
                            className='btn btn-success btn-block'
                            onClick={handleCancel}>
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </>
    )

    return (
        <div className="full-screen-container">
            <div className="password-container">
                <div className="login-image">
                    <img className='logo-img' src='/images/logos/proforum_main.jpg' alt='proforum' />
                </div>
                <h1 className="password-title">Member Password Setup</h1>
                <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
                {pswdForm}
            </div>
        </div>
    )
}

export default MemberPassword;
